<template>
  <div>
    <v-card
      style="margin: 10px 0px 10px 0px;border: 2px solid rgba(0,0,0,0.2);"
    >
      <div style="background:lightgrey;height:10px;width:100%;"></div>
      <v-card-text
        @mouseover="hovering = true"
        @mouseleave="hovering = false"
        style="position:relative;"
      >
        <div
          v-for="subfieldtype in fieldType.subfieldtypes"
          :key="subfieldtype.id"
        >
          <span style="font-weight:900;">{{subfieldtype.text}}</span>
          <v-icon
            v-if="subfieldtype.required"
            size="10"
            color="red"
            style="vertical-align:middle;padding-left: 10px;"
          >
            mdi-asterisk
          </v-icon>
          <AnswerField
            :userFormId="userFormId"
            :question="question"
            :fieldType="subfieldtype"
            :listId="listId"
            :isEmpty="isEmpty"
            @update:listId="$emit('update:listId', arguments[0])"
          />
        </div>
        <v-btn
          v-if="isEmpty && hovering"
          style="position:absolute;right:-25px;top:-25px;"
          fab
          color="red"
          @click="dropRow"
        >
          <v-icon color="white">delete</v-icon>
        </v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import AnswerField from './AnswerField'
import answerListMixin from '@/components/global/answerlistmixin'

export default {
  name: 'AnswerListItem',
  props: [ 'userFormId', 'question', 'fieldType', 'listId' ],
  mixins: [ answerListMixin ],
  components: {
    AnswerField
  },
  data () {
    return {
      isClient: true
    }
  }
}
</script>

<style scoped>
  td {
    vertical-align: bottom;
    padding-right: 4px;
    border-bottom: rgba(0,0,0,0.2) 1px solid;
  }
</style>
